import * as moment from 'moment-mini';
import { SchTravelRequestLegs, SchFirearms } from 'src/models';
import { Gender } from './aims-scheduler-calendarview.component';

export enum DepartAndArriveTypeEnum {
  morning = 1,
  afternoon = 2,
  evening = 3,
  charter = 4,
  mailPlane = 5,
  asAvailable = 6,
  military = 10
}

export enum ScheduleItemStatusEnum {
  approved = 1,
  cancelled = 2,
  pending = 3
}


export enum EmployeeStatusEnum {
  activeAndWorking = 19
}



export enum ScheduleItemTypeEnum {
  flight = 1,
  medical = 2,
  military = 3,
  nonEmployee = 4,
  notAvailable = 5,
  overhire = 6,
  relief = 7,
  rft = 8,
  vacation = 9,
  training_emp = 10,
  training_nonEmp = 11,
  delayed_emp = 12,
  delayed_nonEmp = 13
}

// export enum SitesEnum {
//   phq = 13,
//   anchorage = 19
// }

export enum TravelRequestStatusEnum {
  new = 1,
  cancellation = 2,
  confirmation = 3,
  change = 4,
  quoteOnly = 5
}
export enum TravelRequestBagTypeEnum {
  ppeTools = 1,
  arcticGear = 2,
  personal = 3
}

export enum LodgingAuthTypeEnum {
  yes = 1,
  no = 2,
  enroute = 3
}

export enum RentalCarAuthTypeEnum {
  yes = 1,
  no = 2
}

export enum ViewType {
  day,
  month,
  year,
  calendarAndDetail,
  gantt,
  ganttAndDetail,
  ganttOneWeek,
  ganttTwoWeeks,
  ganttThreeMonths,
  ganttOneYear
}

export class ScheduleView {

  text: string;
  viewType: ViewType;
  duration: { days?: number, months?: number };
  width: number;  //Determines how wide the days are in the view, very important
}

export class SchViews {
  static calendar: ScheduleView = <ScheduleView>{ text: 'Calendar', viewType: ViewType.calendarAndDetail, duration: { months: 1 }, width: null };
  static week: ScheduleView = <ScheduleView>{ text: '1 Week', viewType: ViewType.ganttOneWeek, duration: { days: 7 }, width: 13 };
  static twoWeeks: ScheduleView = <ScheduleView>{ text: '2 Weeks', viewType: ViewType.ganttTwoWeeks, duration: { days: 14 }, width: 6.5 };
  static month: ScheduleView = <ScheduleView>{ text: '1 Month', viewType: ViewType.ganttAndDetail, duration: { months: 1 }, width: 2.95 };
  static threeMonths: ScheduleView = <ScheduleView>{ text: '3 Months', viewType: ViewType.ganttThreeMonths, duration: { months: 3 }, width: .99 };
  static year: ScheduleView = <ScheduleView>{ text: '1 Year', viewType: ViewType.ganttOneYear, duration: { months: 12 }, width: .23 };
  static day: ScheduleView = <ScheduleView>{ text: '1 Day', viewType: ViewType.day, duration: { days: 1 }, width: 4.16 };
}


export class DateRange {
  constructor(selectedView: ViewType, dateInRange: moment.Moment) {
    const sd = moment(dateInRange).startOf('day');
    //For gantt handle the different views
    switch (selectedView) {
      case ViewType.ganttAndDetail: {
        //Set to first and last day of month
        this.start = moment(sd).date(1);
        this.end = moment(this.start).endOf('month');
        break;
      }
      case ViewType.ganttOneWeek: {
        //set to first and last day of week
        this.start = moment(sd).day(0);
        this.end = moment(this.start).endOf('day').day(6);
        break;
      }
      case ViewType.ganttTwoWeeks: {
        //set to first day of week and last day of next week
        this.start = moment(sd).day(0);
        this.end = moment(this.start).endOf('day').add(14, 'days');
        break;
      }
      case ViewType.ganttThreeMonths: {
        //set to first day of this month, last day of three months from now
        this.start = moment(sd).date(1);
        this.end = moment(this.start).endOf('day').add(3, 'months');
        break;
      }
      case ViewType.ganttOneYear: {
        //Set to beginning of this month, and end of month one year out
        this.start = moment(sd).dayOfYear(1);
        this.end = moment(this.start).endOf('year');
        break;
      }
      case ViewType.day: {
        this.start = moment(sd);
        this.end = moment(sd).endOf('day');
        break;
      }
      default: {
        //default is calendar month view == sunday before month starts to saturday after it ends
        this.start = moment(sd).date(1).add(-1, 'days').day(0);
        this.end = moment(sd).endOf('day').date(1).add(-1, 'days').add(1, 'month').day(6);
        break;
      }
    }

    let loopMom = moment(this.start);
    let days = [];
    while (loopMom.isSameOrBefore(this.end, 'day')) {
      this.days.push(moment(loopMom));
      loopMom.add(1, 'day');
    }

  }

  start: moment.Moment;
  end: moment.Moment;
  days: Array<moment.Moment> = [];
}

export class ScheduleFilter {
  constructor(name: string,
    siteId: number,
    jobTitleId: number,
    selectedView: ScheduleView,
    startDate: moment.Moment,
    onlySitePositions: boolean = false,
    onlyNonEmp: boolean = false,
    onlyEmp: boolean = false,
    onlyBilleting: boolean = false,
    onlyTraining: boolean = false,
    onlyFlights: boolean = false,
    onlyOandA: boolean = false,
    onlyPending: boolean = false) {

    this.name = name;
    this.siteId = siteId;
    this.jobTitleId = jobTitleId;
    this.selectedView = selectedView;
    this.dateRange = new DateRange(selectedView.viewType, startDate);
    this.month = moment(this.dateRange.start).add(14, 'days').month();
    this.onlySitePositions = onlySitePositions;
    this.onlyNonEmp = onlyNonEmp;
    this.onlyEmp = onlyEmp;
    this.onlyBilleting = onlyBilleting;
    this.onlyTraining = onlyTraining;
    this.onlyFlights = onlyFlights;
    this.onlyPending = onlyPending;
    this.onlyOandA = onlyOandA;
  }

  updateDateRange(newDateInRange: moment.Moment) {
    this.dateRange = new DateRange(this.selectedView.viewType, newDateInRange);
    this.month = moment(this.dateRange.start).add(14, 'days').month();
  }

  name: string;
  siteId: number;
  jobTitleId: number;
  selectedView: ScheduleView;
  dateRange: DateRange;
  month: number;
  onlySitePositions: boolean = false;
  onlyNonEmp: boolean = false;
  onlyEmp: boolean = false;
  onlyBilleting: boolean = false;
  onlyTraining: boolean = false;
  onlyFlights: boolean = false;
  onlyPending: boolean = false;
  onlyOandA: boolean = false;
}

export class GanttDateClick {
  dateRange: DateRange;
  view: ViewType;
}

export class DetailView {
  constructor(start: moment.Moment, end: moment.Moment, scheduledResources: Array<ScheduledResource>) {
    this.start = start;
    this.end = end;
    this.scheduledResources = scheduledResources;
  }

  start: moment.Moment;
  end: moment.Moment;
  scheduledResources: Array<ScheduledResource>;
}

export class DayOfMonth {
  constructor(day: moment.Moment, inMonth: boolean, scheduled: Array<ScheduledResource>) {
    this.day = day;
    this.isInSelectedMonth = inMonth;
    this.scheduled = scheduled;
    this.iconCount = new IconCounts(scheduled, day);
  }

  day: moment.Moment;
  isInSelectedMonth: boolean;
  scheduled: Array<ScheduledResource>;
  iconCount: IconCounts;
}

export class IconCounts {

  constructor(scheduled: Array<ScheduledResource>, day: moment.Moment) {
    this._scheduled = scheduled;
    this._day = day;

    this.maleBeds = this._scheduled.filter(s => s.scheduleItemStatusId == ScheduleItemStatusEnum.approved && s.billeting && s.gender == Gender.m).length;
    this.femaleBeds = this._scheduled.filter(s => s.scheduleItemStatusId == ScheduleItemStatusEnum.approved && s.billeting && s.gender == Gender.f).length;
    this.otherBeds = this._scheduled.filter(s => s.scheduleItemStatusId == ScheduleItemStatusEnum.approved && s.billeting && s.gender == Gender.g).length;
    this.military = this._scheduled.filter(s => s.scheduleItemStatusId == ScheduleItemStatusEnum.approved && s.scheduleItemTypeId == ScheduleItemTypeEnum.military).length;
    this.vip = this._scheduled.filter(s => s.isVip && s.scheduleItemStatusId == ScheduleItemStatusEnum.approved && s.scheduleItemTypeId != ScheduleItemTypeEnum.vacation && s.scheduleItemTypeId != ScheduleItemTypeEnum.notAvailable).length;
    this.san = this._scheduled.filter(s =>
      s.siteArrivalNoticeRequired &&
      s.scheduleItemStatusId == ScheduleItemStatusEnum.approved &&
      moment(s.start).isSame(this._day, 'day')
    ).length;
    this.sdn = this._scheduled.filter(s =>
      s.siteArrivalNoticeRequired &&
      s.scheduleItemStatusId == ScheduleItemStatusEnum.approved &&
      moment(s.end).isSame(this._day, 'day')
    ).length;

  }

  private _scheduled: Array<ScheduledResource>;
  private _day: moment.Moment;

  public maleBeds: number;
  public femaleBeds: number;
  public otherBeds: number;
  public military: number;
  public vip: number;
  public san: number;
  public sdn: number;
  public flights: number = 0;

}

export class ScheduledResource {
  constructor(start: Date, end: Date) {
    this.start = start;
    this.end = end;
  }

  id: number = 0;
  start: Date;
  end: Date;
  company: string;
  organization: string;
  name: string;
  jobTitleId: number = null;
  jobTitle: string;
  siteId: number = null;
  modifiedOn: Date = null;
  siteName: string = "";
  siteCode: string = "";
  resourceId: number = null;
  employeeId: number = null;
  reliefForId: number = null;
  reliefForName: string;
  overhireJtId: number = null;
  overhireJt: string;
  resourceDescription: string = "";
  scheduleItemTypeId: number;
  requiresApproval: boolean = false;
  isEmployeeSiType: boolean = false;
  color: string;
  isVip: boolean = false;
  isCarrier: boolean = false;
  icon: string = "";
  gender: string;
  travelArrangeReq: boolean = false;
  meals: boolean = false;
  govBilled: boolean = false;
  companyBilled: boolean = false;
  billeting: boolean = false;
  classifiedAccess: boolean = false;
  restrictedAccess: boolean = false;
  comsecaccess: boolean = false;
  teraccess: boolean = false;
  escortOnly: boolean = false;
  restrictedAreaPhotography: boolean = false;
  oanumber: string;
  copaId: number;
  notes: string;
  createdOn: Date = null;
  createdById: number = null;
  clearanceId: number = null;
  reliefForJtId: number = null;
  jtWSId: number = null;
  scheduleItemStatusId: number = ScheduleItemStatusEnum.pending;
  siteArrivalNoticeRequired: boolean = false;
  schTravelRequestLegs: Array<SchTravelRequestLegs> = [];
  confirmArrival: boolean = null;
  confirmDeparture: boolean = null;
  carrierId: number = null;
  flightNumber: string = null;
  arrival: Date = null;
  departure: Date = null;
  arrivalCarrierSchItemId: number = null;
  departureCarrierSchItemId: number = null;
  purpose: string = null;
  firearmRequest: boolean = false;
  schFirearms: Array<SchFirearms> = [];
  radarDowntime: boolean = false;
  transToTopCamp: boolean = false;
  modifiedByFN: string = null;
}
